import type { AuthenticationAccessRight } from "src/authentication/objects/AuthenticationToken";

export class MerchantGroupAccessRight {
  public static VIEW_MERCHANT_GROUPS: AuthenticationAccessRight = ({ menuDisplayLevel }) =>  menuDisplayLevel === 0;
}

/**
 * @deprecated
 */
export default MerchantGroupAccessRight;
